export const lightColors = {
  primary: "#000000",
  background: "#FFFFFF",
  buttonText: "#FFFFFF",
  // Add more colors as needed
};

export const darkColors = {
  primary: "#FFFFFF",
  background: "#131313",
  backgroundTop: "#161616",
  backgroundBottom: "#0E0E0E",
  buttonText: "#020202",
  buttonTop: "#FD8804",
  buttonBottom: "#8E5009",
  gray: "#393939",
  borderGray: "#4B4B4B",
  tableGray: "#484848",
  navbarBlack: "#242424",
  navbarGray: "#282727",
  orange: "#D67406",
  socialIconsGray: "#757575",
  dashedButton: "#E97F06",
  sidebarGray: "#686868",
  sidebarGreenLeft: "#313C2F",
  sidebarGreenRight: "#171F16",
  userProfileBg: "#1A1A1A",
  pagesBgTop: "#101010",
  pagesBgBottom: "#101010",
  seeMore: "#EE8105",
  betOnRaces: "#BEBEBE",
  raceCardBg: "#171717",
  maroon: "#7A6D6D",
  findMatchBlack: "#0F0F0F",
  popupBgTop: "#141414",
  popupBgBottom: "#0E0E0E",
  green: "#56FF7B",
  lightGray: "#898989",
  red: "#DB3535",
  wagerGray: "#707070",
  currencyBg: "#2D2C2C",
  tableGreen: "#48C746",
  // Add more colors as needed
};

export const getColors = (isDarkMode) =>
  isDarkMode ? darkColors : lightColors;
